import { MIN_N } from './stats'
import type { FunnelStepInput } from '../../types/insights'

export type FunnelRow = FunnelStepInput & {
  /** Van de vorige stap door naar deze, in %. `null` bij de eerste stap of te weinig. */
  fromPrevious: number | null
  /** Van de eerste stap tot hier, in %. */
  fromStart: number | null
  /** Deze stap komt uit een andere bron dan de vorige: het percentage is een benadering. */
  mixed: boolean
}

/**
 * De trechter productpagina → in mand → afrekenen gestart → betaald.
 *
 * De eerste stappen komen uit Umami, "betaald" uit de eigen bestellingen (Umami laadt niet op
 * /afrekenen en /bestelling). Twee bronnen kunnen elkaar net tegenspreken (meer betaald dan
 * gestart, bijv. door een adblocker); daarom hoogstens 100% en een vlag `mixed`.
 */
export function funnelRows(steps: readonly FunnelStepInput[]): FunnelRow[] {
  const first = steps[0]?.count ?? 0
  return steps.map((s, i) => {
    const prev = steps[i - 1]
    return {
      ...s,
      fromPrevious: prev ? pct(s.count, prev.count) : null,
      fromStart: i === 0 ? null : pct(s.count, first),
      mixed: Boolean(prev && prev.source !== s.source),
    }
  })
}

const pct = (part: number, whole: number) => (whole < MIN_N ? null : Math.min(100, Math.round((part / whole) * 1000) / 10))
